"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Meta = void 0;
var Meta = /** @class */ (function () {
    function Meta() {
    }
    Object.defineProperty(Meta, "host", {
        get: function () {
            return this.content('mallweb-host');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Meta, "campaignPath", {
        get: function () {
            return this.content('mallweb-campaign-path');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Meta, "inspirationPath", {
        get: function () {
            return this.content('mallweb-inspiration-path');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Meta, "clientURL", {
        get: function () {
            return this.content('mallweb-client-url');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Meta, "hasCanonical", {
        get: function () {
            return document.head.querySelector('link[rel="canonical"]') !== null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Meta, "useHash", {
        get: function () {
            return this.content('mallweb-use-hash') === 'true';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Meta, "scrollTopOffset", {
        get: function () {
            return this.content('mallweb-scroll-top-offset');
        },
        enumerable: false,
        configurable: true
    });
    Meta.content = function (name) {
        var value = document.head.querySelector('meta[name="' + name + '"]');
        if (value) {
            var content = value.getAttribute('content');
            if (content) {
                return content;
            }
        }
        throw new Error('Could not get meta value for name: ' + name + '. Please check that you added a meta tag with that name.');
    };
    return Meta;
}());
exports.Meta = Meta;
